import { useEffect } from 'react';
import { getWindow } from '../utils/general';
import { useCommonContext } from './useContexts';
/**
 * Custom hook to load and run the QSI API when `trigger` is true and/or device type changes.
 * @param options - Options to control when the QSI API should be triggered.
 * @default - { trigger: true } meaning it will trigger the QSI API by default, unless prop is supplied.
 */
export function useQSIApi(_a) {
    var _b = _a.trigger, trigger = _b === void 0 ? true : _b;
    var _c = useCommonContext(), isMobile = _c.isMobile, isTablet = _c.isTablet, isDesktop = _c.isDesktop;
    var windowObj = getWindow();
    // Effect to call QSI API when first loaded, or when the trigger is supplied and true.
    useEffect(function () {
        var timerId;
        if (trigger) {
            timerId = setTimeout(function () {
                if ((windowObj === null || windowObj === void 0 ? void 0 : windowObj.QSI) && (windowObj === null || windowObj === void 0 ? void 0 : windowObj.QSI.API)) {
                    // Load the survey script
                    windowObj === null || windowObj === void 0 ? void 0 : windowObj.QSI.API.load();
                    windowObj === null || windowObj === void 0 ? void 0 : windowObj.QSI.API.run();
                }
            }, 200);
        }
        return function () { return clearTimeout(timerId); };
    }, [trigger]);
    // Effect to trigger QSI API calls only when device type changes (mobile/tablet/desktop) and the trigger prop is true
    useEffect(function () {
        if (trigger && (isMobile || isTablet || isDesktop)) {
            if ((windowObj === null || windowObj === void 0 ? void 0 : windowObj.QSI) && (windowObj === null || windowObj === void 0 ? void 0 : windowObj.QSI.API)) {
                windowObj.QSI.API.unload();
                windowObj.QSI.API.load();
                windowObj.QSI.API.run();
            }
        }
    }, [trigger, isMobile, isTablet, isDesktop]);
}
